import { render, staticRenderFns } from "./SchoolBtn.vue?vue&type=template&id=5ed20b3b&scoped=true&"
import script from "./SchoolBtn.vue?vue&type=script&lang=js&"
export * from "./SchoolBtn.vue?vue&type=script&lang=js&"
import style0 from "./SchoolBtn.vue?vue&type=style&index=0&id=5ed20b3b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed20b3b",
  null
  
)

export default component.exports